(function(){
'use strict';
var root=document.getElementById('RCAuctionCart');
if(!root||root.dataset.bound==='1'||root.dataset.customer!=='1')return;
root.dataset.bound='1';
var API='https://kttwdpuuxvnspcscjwiz.supabase.co',KEY='sb_publishable__-Qftq8nHRn_gAKUfyF6FA_sGyPY0AW';
var customerId=String(root.dataset.customerId||''),email=String(root.dataset.email||'').toLowerCase();
var auctions=[],busy=false,serverOffset=0,cart=null,lastRefresh=0,strikeCount=0,strikeExempt=false;
var body=root.querySelector('[data-rc-auction-cart-body]');
var summary=document.querySelector('.rc-cart-summary'),form=document.querySelector('.rc-cart-page__form');
var session=null,sessionClient=null;
var formatter=new Intl.NumberFormat('fr-CA',{style:'currency',currency:'CAD'});
function money(c){return formatter.format((Number(c)||0)/100)}
function escape(v){return String(v==null?'':v).replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]})}
function remaining(iso){
 var n=Math.max(0,Date.parse(iso)-Date.now()-serverOffset),sec=Math.floor(n/1000),days=Math.floor(sec/86400),hr=Math.floor((sec%86400)/3600),min=Math.floor((sec%3600)/60),ss=sec%60;
 return (days?days+' j ':'')+String(hr).padStart(2,'0')+':'+String(min).padStart(2,'0')+':'+String(ss).padStart(2,'0')
}
var errors={CART_PROPERTIES_UNSUPPORTED:'Un article personnalisé nécessite une vérification de ses options avant le paiement combiné. Aucun détail de personnalisation ne sera supprimé.',LOGIN_REQUIRED:'Reconnectez-vous à votre compte pour afficher les enchères remportées.',ACCOUNT_MISMATCH:'La session des enchères ne correspond pas au compte Shopify connecté.',OFFER_CHANGED:'Cette enchère a été attribuée à un autre client. Rechargez la page.',PAYMENT_EXPIRED:'Le délai de 48 heures est terminé. La commande est en cours de vérification.',OFFER_BUSY:'Cette enchère est déjà en cours de vérification. Réessayez dans quelques instants.',PAYMENT_PREPARING:'Votre facture Shopify est en préparation. Réessayez prochainement.',FREE_SHIPPING_THRESHOLD:'Ajoutez des articles pour atteindre 100 $ et profiter du paiement groupé avec livraison gratuite.',CHECKOUT_ALREADY_STARTED:'Un paiement a peut-être déjà commencé. Consultez votre lien Shopify original pour éviter une double commande.',PRODUCT_UNAVAILABLE:'Un article de votre panier n’est plus disponible.',CHECKOUT_UPDATE_FAILED:'Shopify n’a pas pu préparer la commande combinée.',SHOPIFY_UNAVAILABLE:'Le paiement Shopify est temporairement indisponible.',CANNOT_CANCEL_INVOICE:'Impossible de retirer l’enchère en sécurité : un paiement peut être en cours.',TRANSFER_REQUIRES_REVIEW:'Le transfert doit être vérifié par Rustique Chic. Le paiement est bloqué pour cette enchère.',INVALID_CART:'Votre panier doit être actualisé. Rechargez la page.',AUCTION_DUPLICATE_VARIANT:'Cet article figure aussi dans votre panier normal. Retirez sa copie au prix régulier pour ne pas payer deux fois la même pièce.',CART_LOCKED_FOR_PAYMENT:'Votre facture combinée est déjà préparée. Terminez-la avec le lien existant; elle ne peut plus être modifiée en cours de paiement.',CHECKOUT_CALCULATION_FAILED:'Shopify n’a pas pu confirmer les totaux de la commande.',CHECKOUT_TOTALS_UNVERIFIED:'Le montant de la commande n’a pas pu être confirmé. Aucun paiement ne doit être effectué.',DISCOUNTS_REVIEW_REQUIRED:'Un rabais est déjà appliqué à votre panier. Pour éviter de perdre cet avantage, le paiement groupé est bloqué jusqu’à vérification. Vous pouvez payer l’enchère séparément.',SHIPPING_PROFILE_REVIEW:'Les frais de livraison de cet article doivent être vérifiés. Aucun tarif n’est inventé.',INVALID_AUCTION_GROUP:'La liste des enchères gagnées est invalide.',GROUP_STATUS_UNAVAILABLE:'Impossible de vérifier le groupe de paiement en ce moment.',CART_LOCKED_FOR_PAYMENT:'Cette facture groupée est déjà préparée. Vous pouvez reprendre le paiement avec le lien Shopify reçu.',GROUP_REGISTRATION_FAILED:'Le regroupement n’a pas pu être validé. Les factures individuelles doivent être vérifiées.',GROUP_ABORT_REQUIRES_REVIEW:'Le retrait nécessite une vérification du groupe de paiement.',CHECKOUT_CREATE_FAILED:'La facture combinée n’a pas pu être créée.',GROUP_OFFER_CHANGED:'Une des enchères a changé de gagnant, de statut ou de délai.'};
function errorText(err){var code=err&&err.code||'';return errors[code]||'Cette opération n’a pas pu être terminée. Veuillez réessayer.'}
function message(s,kind){var el=root.querySelector('[data-rc-auction-cart-message]');if(!el)return;el.textContent=s||'';el.className='rc-auction-cart__message '+(kind?'is-'+kind:'');el.hidden=!s}
function setBusy(v){busy=v;root.querySelectorAll('button').forEach(function(el){el.disabled=v});if(summary){var b=summary.querySelector('[name="checkout"]');if(b)b.disabled=v}}
async function bridge(){
 if(!window.supabase||!window.supabase.createClient)throw Error('AUTH_NOT_READY');
 sessionClient=window.supabase.createClient(API,KEY,{auth:{persistSession:true,autoRefreshToken:true}});
 var prior=(await sessionClient.auth.getSession()).data.session;
 if(prior&&String(prior.user?.email||'').toLowerCase()===email){session=prior;return}
 var b=await fetch(API+'/functions/v1/shopify-auction-session',{method:'POST',mode:'cors',cache:'no-store',headers:{apikey:KEY,'Content-Type':'application/json'},body:JSON.stringify({customer_id:customerId,email,ts:Number(root.dataset.ts),sig:root.dataset.sig})});
 var data=await b.json();if(!b.ok||!data.ok||!data.token_hash)throw Error('ACCOUNT_MISMATCH');
 var v=await fetch(API+'/auth/v1/verify',{method:'POST',mode:'cors',cache:'no-store',headers:{apikey:KEY,'Content-Type':'application/json'},body:JSON.stringify({token_hash:data.token_hash,type:'email'})});
 var auth=await v.json();if(!v.ok||!auth.access_token)throw Error('LOGIN_REQUIRED');
 auth.expires_at=Math.floor(Date.now()/1000)+Number(auth.expires_in||3600);
 try{localStorage.setItem('rc-auctions-session-v1',JSON.stringify(auth));localStorage.setItem('rc-auctions-shopify-link-v1',customerId)}catch(_){}
 session=auth;
}
async function call(action,more){
 if(!sessionClient)throw Error('LOGIN_REQUIRED');
 var s=(await sessionClient.auth.getSession()).data.session;
 if(!s||String(s.user?.email||'').toLowerCase()!==email)throw Object.assign(Error('LOGIN_REQUIRED'),{code:'LOGIN_REQUIRED'});
 var controller=new AbortController(),time=setTimeout(function(){controller.abort()},25000);
 try{
  var r=await fetch(API+'/functions/v1/rc-auction-cart-v23',{method:'POST',mode:'cors',cache:'no-store',credentials:'omit',signal:controller.signal,headers:{'Content-Type':'application/json',apikey:KEY,Authorization:'Bearer '+s.access_token},body:JSON.stringify(Object.assign({action,customer_id:customerId,email},more||{}))});
  var response=await r.json().catch(function(){return {code:'REQUEST_FAILED'}});
  if(!r.ok||!response.ok)throw Object.assign(Error(response.code||'REQUEST_FAILED'),response);
  return response;
 }finally{clearTimeout(time)}
}
async function readCart(){
 var r=await fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
 if(!r.ok)throw Error('INVALID_CART');cart=await r.json();return cart;
}
function currentCartSignature(c){
 return JSON.stringify((c.items||[]).map(function(item){return {key:item.key,quantity:item.quantity}}).sort(function(a,b){return a.key.localeCompare(b.key)}))
}
async function cleanupPaidCombinedCart(){
 var record;
 try{record=JSON.parse(localStorage.getItem('rc-auction-combined-pending-v14')||'null')}catch(_){}
 if(!record||!record.auction_id)return;
 var status;
 try{status=await call('payment_status',{auction_id:record.auction_id})}catch(_){return}
 if(!status.paid)return;
 var fresh=await readCart();
 if(record.cart_token&&String(fresh.token||'')===record.cart_token&&currentCartSignature(fresh)===record.cart_signature){
  var removed=await fetch('/cart/clear.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'}});
  if(removed.ok){
   try{localStorage.removeItem('rc-auction-combined-pending-v14')}catch(_){}
   window.location.reload();return;
  }
 }
 try{localStorage.removeItem('rc-auction-combined-pending-v14')}catch(_){}
 var warn=document.createElement('p');
 warn.className='rc-auction-cart__warning';
 warn.textContent='Votre commande combinée est payée. Vérifiez les produits restés dans votre panier avant de commander à nouveau.';
 var header=document.querySelector('.rc-cart-page__head');
 if(header)header.insertAdjacentElement('afterend',warn);
}
function noteAuctionVisit(a){try{localStorage.setItem('rc-cart-won-'+a.auction_id+'-'+a.round,'1')}catch(_){}}
function buttons(a,expired){
 if(expired)return '<span class="rc-auction-cart__expired">Délai de paiement terminé — vérification en cours</span>';
 return '<div class="rc-auction-cart__actions">'+
 '<button type="button" class="rc-auction-cart__decline" data-rc-auction-decline="'+escape(a.auction_id)+'">Retirer définitivement</button></div>';
}
function updateMainSubtotal(active){
 if(!summary)return;
 var normal=Number(cart&&cart.total_price||0);
 var won=(active||[]).reduce(function(n,x){return n+Number(x.amount_cents||0)},0);
 var label=summary.querySelector('[data-rc-cart-subtotal-label]'),value=summary.querySelector('[data-rc-cart-subtotal-value]'),detail=summary.querySelector('[data-rc-cart-breakdown]');
 if(label)label.textContent=won?'Sous-total avec enchères':'Sous-total';
 if(value)value.textContent=money(normal+won);
 if(detail){detail.hidden=!won;detail.textContent=won?('Produits réguliers : '+money(normal)+' · Enchères gagnées : '+money(won)):'';}
}
function render(){
 if(!auctions.length){
  updateMainSubtotal([]);
  if(summary){
   var oldCombined=summary.querySelector('[data-rc-auction-summary]');
   if(oldCombined)oldCombined.remove();
   var normalHint=document.getElementById('RCCartDeliveryHint');
   if(normalHint)normalHint.textContent='Paiement normal avec les tarifs Shopify habituels, dont la livraison gratuite dès 100 $.';
  }
  root.hidden=true;root.classList.remove('has-auction');document.body.classList.remove('rc-cart-with-auction');
  var empty=document.querySelector('.rc-cart-page__empty');if(empty)empty.hidden=false;return;
 }
 root.hidden=false;root.classList.add('has-auction');document.body.classList.add('rc-cart-with-auction');
 var active=auctions.filter(function(x){return !x.paid&&Date.parse(x.deadline)>Date.now()+serverOffset});
 var total=active.reduce(function(n,x){return n+x.amount_cents},0);
 var original=cart?cart.total_price:0;
 var subtotal=original+total;
 updateMainSubtotal(active);
 var plural=active.length>1;
 var html='<div class="rc-auction-cart__head"><div><span class="rc-auction-cart__eyebrow">ENCHÈRES REMPORTÉES</span><h2>Vos pièces réservées</h2><p>Vos enchères gagnées suivent votre compte et restent réservées jusqu’à leur échéance. Ajouter des produits ne prolonge pas les 48 heures.</p></div><span class="rc-auction-cart__count">'+active.length+' enchère(s)</span></div>';
 html+=auctions.map(function(a){
  var expired=Date.parse(a.deadline)<=Date.now()+serverOffset;
  return '<article class="rc-auction-cart__line" data-rc-won-id="'+escape(a.auction_id)+'"><div class="rc-auction-cart__image">'+(a.image_url?'<img loading="lazy" src="'+escape(a.image_url)+'" alt="'+escape(a.title)+'">':'')+'</div>'+
  '<div class="rc-auction-cart__detail"><p class="rc-auction-cart__tag">Enchère gagnée · Prix garanti</p><h3>'+escape(a.title)+'</h3><strong class="rc-auction-cart__amount">'+money(a.amount_cents)+'</strong>'+
  '<p class="rc-auction-cart__timer">Temps restant : <strong data-rc-won-deadline="'+escape(a.deadline)+'">'+remaining(a.deadline)+'</strong></p>'+buttons(a,expired)+'</div></article>';
 }).join('');
 if(!strikeExempt&&strikeCount===1)html+='<p class="rc-auction-cart__encouragement"><strong>Une chance de vous reprendre ♡</strong> Vous avez une faute active. Si vous payez cette nouvelle enchère remportée, elle sera effacée après vérification du paiement Shopify. Merci de continuer l’aventure Rustique Chic.</p>';
  if(plural)html+='<p class="rc-auction-cart__shipping">✓ Vous pouvez réunir ces enchères en une seule commande. Chacune conserve sa limite de paiement de 48 h.</p>';
 html+='<div class="rc-auction-cart__totals" aria-live="polite"><span>Produits réguliers</span><strong>'+money(original)+'</strong><span>Enchère'+(active.length>1?'s':'')+' gagnée'+(active.length>1?'s':'')+'</span><strong>'+money(total)+'</strong><span>Total combiné avant taxes</span><strong>'+money(subtotal)+'</strong></div>';
 if(active.length){
  html+='<p class="rc-auction-cart__shipping">'+(subtotal>=10000?
    '✓ Livraison gratuite dès 100 $ pour la commande combinée.':
    'Les produits réguliers et les enchères gagnées comptent ensemble pour les frais de livraison. Ajoutez encore '+money(10000-subtotal)+' pour la livraison gratuite.')+'</p>';
  if(active.length>8)html+='<p class="rc-auction-cart__warning">Regroupement limité à 8 enchères par paiement.</p>';
  if(!summary&&active.length<=8)html+='<button type="button" class="rc-auction-cart__checkout" data-rc-auction-combine>Passer la commande →</button>';
 }
 html+='<p class="rc-auction-cart__message" data-rc-auction-cart-message hidden role="status" aria-live="polite"></p><a class="rc-auction-cart__continue" href="/?category=all#collection">Continuer mes achats dans la boutique →</a>';
 body.innerHTML=html;
 var empty=document.querySelector('.rc-cart-page__empty');if(empty&&active.length)empty.hidden=true;
 if(summary){
  var subline=summary.querySelector('[data-rc-auction-summary]');
  if(!subline){subline=document.createElement('small');subline.setAttribute('data-rc-auction-summary','');summary.insertBefore(subline,summary.querySelector('[name="checkout"]'))}
  var shippingHint=document.getElementById('RCCartDeliveryHint');
  if(shippingHint&&active.length)shippingHint.textContent='Le bouton ci-dessus vérifie d’abord vos enchères gagnées et prépare votre paiement Shopify combiné. La livraison gratuite est calculée dès 100 $ de produits et d’enchères.';
  subline.innerHTML='<span class="rc-v16-cart-confirm__shipping">'+(subtotal>=10000?'✓ Livraison gratuite dès 100 $ cumulés':'Encore '+money(10000-subtotal)+' pour la livraison gratuite')+'</span><small>Les enchères gagnées sont incluses dans le sous-total ci-dessus. Shopify vérifie le paiement combiné et la livraison.</small>';
 }
}
async function refresh(){
 if(busy)return;
 lastRefresh=Date.now();
 await cleanupPaidCombinedCart();
 await readCart();
 var res=await call('list');
 serverOffset=Date.parse(res.server_now)-Date.now();
 auctions=(res.auctions||[]).filter(function(x){return !x.paid});
  strikeCount=Math.max(0,Number(res.strike_count||0));
  strikeExempt=res.strike_exempt===true;
 auctions.forEach(noteAuctionVisit);
 render();
}
async function payTogether(){
 if(busy)return;
 var pending=auctions.filter(function(x){return !x.paid&&Date.parse(x.deadline)>Date.now()+serverOffset});
 if(pending.length<1||pending.length>8){message('Le paiement groupé accepte entre 1 et 8 enchères.','error');return}
 var a=pending[0];
 if(Date.now()+serverOffset>=Date.parse(a.deadline)){message('Le délai est expiré. Rechargez votre panier.','error');return}
 setBusy(true);message('Validation de votre enchère et préparation du paiement Shopify…');
 try{
  var fresh=await readCart();
  if(Number(fresh.total_discount||0)>0||(fresh.cart_level_discount_applications||[]).length||(fresh.items||[]).some(function(x){return Number(x.final_price||0)<Number(x.original_price||0)}))throw Object.assign(Error('DISCOUNTS_REVIEW_REQUIRED'),{code:'DISCOUNTS_REVIEW_REQUIRED'});
  var items=fresh.items.map(function(x){
   var props=x.properties||{},fields=Object.entries(props);
   if(fields.length>18||fields.some(function(p){return !p[0]||p[0].length>90||p[1]===null||p[1]===undefined||typeof p[1]==='object'||String(p[1]).length>1000}))
     throw Object.assign(Error('CART_PROPERTIES_UNSUPPORTED'),{code:'CART_PROPERTIES_UNSUPPORTED'});
   return{id:'gid://shopify/ProductVariant/'+String(x.id),quantity:x.quantity,properties:props};
  });
  var d=await call('combine',{auction_id:a.auction_id,auction_ids:pending.map(function(x){return x.auction_id}),items});
  if(!d.checkout_url)throw Error('CHECKOUT_UPDATE_FAILED');
  var verifiedTotal=Number(fresh.total_price||0)+pending.reduce(function(n,x){return n+Number(x.amount_cents||0)},0);
  var standaloneAllowed=d.combined===false&&pending.length===1&&fresh.items.length===0&&
    Number(pending[0].amount_cents)<10000;
  if(!standaloneAllowed&&
    (d.combined!==true||Number(d.subtotal_cents)!==verifiedTotal||
    (verifiedTotal>=10000&&Number(d.shipping_cents)!==0)))
    throw Object.assign(Error('CHECKOUT_TOTALS_UNVERIFIED'),{code:'CHECKOUT_TOTALS_UNVERIFIED'});
  if(d.combined===true){
    try{localStorage.setItem('rc-auction-combined-pending-v14',JSON.stringify({
      auction_id:a.auction_id,auction_ids:pending.map(function(x){return x.auction_id}),cart_token:String(fresh.token||''),cart_signature:currentCartSignature(fresh)
    }))}catch(_){}
  }
  var dest=new URL(d.checkout_url);
  if(dest.protocol!=='https:'||!['rustiquechic.com','www.rustiquechic.com','a3t7dw-tr.myshopify.com'].includes(dest.hostname))throw Error('CHECKOUT_UPDATE_FAILED');
  location.assign(dest.href);
 }catch(e){
  if(e.code==='FREE_SHIPPING_THRESHOLD'&&Number.isFinite(e.missing_cents))message('Ajoutez encore '+money(e.missing_cents)+' de produits réguliers pour profiter du paiement groupé avec livraison gratuite.','error');
  else message(errorText(e),'error');
  setBusy(false);
 }
}
async function decline(id){
 var a=auctions.find(function(x){return x.auction_id===id});if(!a||busy)return;
 var firstWarning=strikeExempt
  ? 'Voulez-vous vraiment retirer cette enchère remportée ? Votre compte est exempté des fautes, mais vous perdrez le droit d’achat.'
  : (strikeCount>=1
   ? 'Vous avez une faute active. En payant cette nouvelle enchère gagnée, vous pourriez la faire effacer. Si vous renoncez à nouveau, vous atteindrez 2 fautes et votre compte sera banni de Rustique Chic. Voulez-vous vraiment renoncer ?'
   : 'ATTENTION : retirer une enchère remportée donne 1 FAUTE. Au bout de 2 fautes, vous serez BANNI DÉFINITIVEMENT du système d’enchères Rustique Chic. Continuer ?');
 if(!window.confirm(firstWarning))return;
 if(!window.confirm('Vous perdrez immédiatement votre droit d’achat et la pièce sera proposée au prochain enchérisseur. Cette action est irréversible. Confirmer ?'))return;
 if(window.prompt(strikeExempt
  ? 'Dernière confirmation : écrivez JE RENONCE pour retirer définitivement votre enchère.'
  : 'Dernière confirmation : écrivez JE RENONCE pour retirer cette enchère et recevoir une faute.')!=='JE RENONCE')return;
 setBusy(true);message('Vérification du paiement et transfert au prochain enchérisseur…');
 try{
  var data=await call('decline',{auction_id:id,confirm:'JE RENONCE'});
  strikeExempt=data.strike_exempt===true;
  if(strikeExempt){
   strikeCount=0;
   message('Retrait confirmé. Votre compte est exempté des fautes : aucune sanction ajoutée.','success');
   window.alert('Enchère retirée. Aucune faute n’a été attribuée à votre compte.');
  }else{
   strikeCount=Math.max(0,Number(data.strike_count??(strikeCount+1)));
   var banned=data.permanently_banned===true;
   message(banned
    ? '2/2 fautes : votre compte est désormais banni définitivement des enchères Rustique Chic.'
    : 'Retrait confirmé. '+strikeCount+'/2 faute(s). Vous pourrez effacer votre faute en payant une nouvelle enchère remportée.',
    banned?'error':'success');
   window.alert(banned
    ? 'Vous avez maintenant 2 fautes : votre accès aux enchères Rustique Chic est définitivement suspendu.'
    : 'Retrait enregistré : '+strikeCount+' faute sur 2. Une enchère remportée puis payée peut effacer cette faute avant un deuxième abandon.');
  }
  if(data.permanently_banned===true){window.location.reload();return;}
  auctions=auctions.filter(function(x){return x.auction_id!==id});setBusy(false);render();setTimeout(function(){refresh().catch(function(){})},1200);
 }catch(e){message(errorText(e),'error');setBusy(false)}
}
root.addEventListener('click',function(e){
 var remove=e.target.closest('[data-rc-auction-decline]');if(remove){decline(remove.dataset.rcAuctionDecline);return}
 if(e.target.closest('[data-rc-auction-combine]')){payTogether();return}
});
// V20 — Ne jamais laisser la caisse normale contourner la vérification des
// enchères gagnées. Cette garde est limitée au bouton d'envoi du panier.
// Le bouton Ramassage conserve ses propres gestionnaires et fonctionne séparément.
var auctionStateReady=false,initialLoadPromise=null,guardCheckoutBusy=false,nativeCheckoutOnce=false;
var normalCheckoutButton=summary&&(summary.querySelector('[data-rc-unified-checkout]')||summary.querySelector('button[name="checkout"]'));
function hasPayableAuction(){
 return auctions.some(function(a){return !a.paid&&Date.parse(a.deadline)>Date.now()+serverOffset});
}
async function verifyCheckoutRoute(){
 if(initialLoadPromise)await initialLoadPromise;
 if(!auctionStateReady){
  await bridge();
  await refresh();
  auctionStateReady=true;
 }
 if(Date.now()-lastRefresh>12000){
  await refresh();
  auctionStateReady=true;
 }
}
async function guardedCheckout(){
 if(guardCheckoutBusy||busy)return;
 guardCheckoutBusy=true;
 if(normalCheckoutButton)normalCheckoutButton.disabled=true;
 try{
  var cartPage=document.querySelector('.rc-cart-page');
  var unsaved=cartPage&&cartPage.classList.contains('rc-cart-updating');
  if(form)unsaved=unsaved||Array.from(form.querySelectorAll('input[name="updates[]"]')).some(function(x){return Number(x.value)!==Number(x.dataset.rcCurrentQuantity||x.defaultValue)});
  if(unsaved){message('Les quantités sont en cours de sauvegarde. Attendez avant de continuer.','error');return}
  await verifyCheckoutRoute();
  if(hasPayableAuction()){
   // Pas de fenêtre de confirmation supplémentaire : après les contrôles
   // du panier, ouvrir directement la caisse Shopify combinée.
   // Ne jamais contourner le contrôle du montant et de la livraison gratuite.
   await verifyCheckoutRoute();
   await payTogether();
  }else{
   // Aucun gain en cours : envoyer le panier normal via le bouton Shopify
   // original, avec son nom "checkout" (ne touche pas au ramassage).
   if(!form||!normalCheckoutButton||typeof form.requestSubmit!=="function"||typeof form.appendChild!=="function")
    throw Error("INVALID_CART");
   // Client Shopify connecté SANS enchère gagnée : recréer uniquement au
   // moment du clic un bouton natif name="checkout" pour garder le paiement
   // Shopify habituel, puis retirer ce bouton technique invisible.
   var nativeBtn=document.createElement('button');
   nativeBtn.type='submit';nativeBtn.name='checkout';nativeBtn.value='1';
   nativeBtn.hidden=true;
   form.appendChild(nativeBtn);
   nativeCheckoutOnce=true;
   try{form.requestSubmit(nativeBtn)}
   finally{nativeCheckoutOnce=false;if(nativeBtn.parentNode)nativeBtn.parentNode.removeChild(nativeBtn)}
  }
 }catch(e){
  message("Impossible de vérifier votre paiement et vos enchères. Aucune commande n'a été soumise. Rechargez la page ou reconnectez-vous.",'error');
  if(root.hidden){root.hidden=false;root.classList.add('has-auction')}
 }finally{
  guardCheckoutBusy=false;
  if(normalCheckoutButton&&!busy)normalCheckoutButton.disabled=false;
 }
}
// Utiliser l'original « Passer la commande »; aucun bouton ajouté.
// Capture du clic AVANT la soumission native, même si le chargement asynchrone
// de l'utilisateur et des enchères n'est pas terminé.
if(normalCheckoutButton)window.addEventListener('click',function(e){
 if(!normalCheckoutButton.contains(e.target))return;
 if(nativeCheckoutOnce)return;
 e.preventDefault();
 e.stopImmediatePropagation();
 guardedCheckout();
},true);
if(form)form.addEventListener('submit',function(e){
 if(nativeCheckoutOnce)return;
 e.preventDefault();
 e.stopImmediatePropagation();
 guardedCheckout();
},true);
var timer=setInterval(function(){
 if(root.hidden)return;
 root.querySelectorAll('[data-rc-won-deadline]').forEach(function(el){el.textContent=remaining(el.dataset.rcWonDeadline)});
 if(Date.now()-lastRefresh>75000&&!document.hidden)refresh().catch(function(){});
},1000);
document.addEventListener('rc-cart-updated',function(event){
 if(event.detail?.cart){cart=event.detail.cart;render()}
});
document.addEventListener('visibilitychange',function(){if(!document.hidden&&Date.now()-lastRefresh>10000)refresh().catch(function(){})});
initialLoadPromise=(async function(){
 try{await bridge();await refresh();auctionStateReady=true}
 catch(e){
  auctionStateReady=false;
  root.hidden=false;
  body.innerHTML='<div class="rc-auction-cart__warning">Impossible de vérifier les enchères gagnées. Rechargez la page ou reconnectez-vous avant de payer.</div>';
 }
})();
})();